import { get, isEmpty, isPojo } from '../../utilities'
import Input from './Input'
import Level from './Level'

const schema = {

    model: null,
    config: null,
    components: null,
    style: null,
    arguments: {},

    init(model, 
        components, 
        config) {
        this.model = model
        this.components = components
        this.config = config
        this.style = Object.assign({}, 
            model.graphql[config.graphql], 
            config.style)
        this.arguments = this.getArgs(this.style.parameters || {}, {})

        return this
    },

    query() {
        return this.build('query')
    },

    mutate() {
        return this.build('mutation')
    },

    build(action = 'query') {
        const variables = this.variables()
        const type = this.schemaName()
        var str = action + ' ' + type
        str += this.buildFunction()

        const level = new Level(this.model, 
            this.components,
            this.style)
        str += level.build()
        str += '}'
        return { query: str, variables }
    },

    schemaName() {
        return get(this, 
            'style.type', 
            this.model.entity)
    },

    variables() {
        const parameters = this.arguments
        const variables = this.config.variables

        var temp = {}
        for (var key in parameters) {
            var variable = variables[key]
            var parameter = parameters[key]
            
            temp[key] = (parameter instanceof Input)
                ? parameter.fields(variables) 
                : variable
        }
        return temp
    },

    buildFunction() {
        const args = this.arguments
        const argsStr = this.buildArgs(args, (key) => {
            return '$'+key+':'+this.buildArgKey(args[key])
        })
        if (isEmpty(argsStr)) { return '{ ' }
        return '(' + argsStr + ') {'
    },

    buildArgs(parameters, mapping) {
        return Object.keys(parameters)
            .map(mapping)
            .join(',')
    },

    buildArgKey(key) {
        if (key instanceof Input) {
            return key.type
        }
        return key
    },

    getArgs(parameters, obj) {
        const keys = Object.keys(parameters)
        for (var key of keys) {
            var item = parameters[key]
            if (isPojo(item)) {
                this.getArgs(item, obj)
            }
            else {
                obj[key] = item
            }
        }
        return obj
    }
}

export default schema